import styled from '@emotion/styled';

import { screen } from '@/components/common/breakpoints';
import { Heading, HeadingLevel } from '@/components/common/MarkUp';
import { Section } from '@/components/layout/Section';
import { BlogCards } from '@/components/page/blog/generateBlogCards';

import type { BackgroundColourType } from '@/types/colours';
import type { BlogPostPreview } from '@/types/shared';

export interface RelatedPostsProps {
  backgroundColour: BackgroundColourType;
  fallbackImage: any;
  fallbackAuthorImage: any;
  posts: BlogPostPreview[];
}

const RelatedPosts = ({
  fallbackImage,
  fallbackAuthorImage,
  posts,
}: RelatedPostsProps) => {
  return (
    <Section backgroundColour="--background-warm-base">
      <ColumnsContainer>
        <TitleContainer>
          <HeadingLevel>
            <Heading size="headline-lg">Related posts</Heading>
          </HeadingLevel>
        </TitleContainer>
        <Columns>
          {posts.map((post) => (
            <BlogCards
              post={post}
              key={post._id}
              fallbackImage={fallbackImage}
              fallbackAuthorImage={fallbackAuthorImage}
            />
          ))}
        </Columns>
      </ColumnsContainer>
    </Section>
  );
};
const ColumnsContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

const TitleContainer = styled.div`
  margin: var(--spacing-1000) 0 var(--spacing-800);
`;

const Columns = styled.div`
  display: flex;
  flex-direction: column;
  padding-bottom: var(--spacing-600);
  gap: var(--spacing-200);

  ${screen.md} {
    flex-direction: row;
    justify-content: space-between;
  }

  ${screen.lg} {
    gap: var(--spacing-300);
  }
`;

export { RelatedPosts };
